import axios from 'axios';
import buildPaginationQueryOpts from "@/shared/sort/sorts";

const baseApiUrl = 'api/reports/appeal';

export default class AppealReportService {
  public getReport1(filter: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(baseApiUrl + `/report-1`, filter)
        .then(function (res) {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
  public getReport5(filter: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(baseApiUrl + `/report-5`, filter)
        .then(function (res) {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
  public getReport2(filter: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(baseApiUrl + `/report-2`, filter)
        .then(function (res) {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
  public getReport4(filter: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(baseApiUrl + `/report-4`, filter)
        .then(function (res) {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
  public getReport3(filter: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(baseApiUrl + `/report-3`, filter)
        .then(function (res) {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  downloadReport1Excel(filter: { range: { from: string; to: string } }) {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}/report-1-excel`, filter, {
          responseType: 'blob',
        })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  downloadReport5Excel(filter: { range: { from: string; to: string } }) {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}/report-5-excel`, filter, {
          responseType: 'blob',
        })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  downloadReport2Excel(filter: { range: { from: string; to: string } }) {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}/report-2-excel`, filter, {
          responseType: 'blob',
        })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  downloadReport4Excel(filter: { range: { from: string; to: string } }) {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}/report-4-excel`, filter, {
          responseType: 'blob',
        })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  downloadReport3Excel(filter: { range: { from: string; to: string } }) {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}/report-3-excel`, filter, {
          responseType: 'blob',
        })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
